import request from "@/api/request";
import { ApiResponse } from '@gry-dmitrij/api-request';

export interface IMemberStat {
  activeMembersAmount: number
  date: string
  messageAmount: number
  newMembersAmount: number
}

interface IMembersStats {
  data: IMemberStat[]
}

export const statisticsApi = async(): Promise<IMemberStat[]> => {
  const { data: { data } }: ApiResponse<IMembersStats> = await request('post', '/api/statistics', {})
  return data
}
